import { createSelector } from 'reselect'
import { IOfflineRecord } from './interface'

export const baseState = (state: any): IOfflineRecord => state.get('persist').offline

export const isWaiting = createSelector(baseState, state => state.get('isWaiting'))
export const isOffline = createSelector(baseState, state => state.get('isOffline'))
export const waitingList = createSelector(baseState, state => state.get('waitingList'))
export const lastAction = createSelector(baseState, state => state.get('lastAction'))
